// api.js
import axios from "axios";
import {
  ACCOUNTS_MS_API_URL,
  API_URL,
  COOKIES_TOKEN_NAME,
  RIDE_MS_URL,
} from "./constants";
// import { handleLogout } from "./utils";
import Cookies from "js-cookie";

const getAuthHeader = () => {
  const authToken = Cookies.get(`${COOKIES_TOKEN_NAME}`);
  return authToken ? `Bearer ${authToken}` : "";
};

const api = axios.create({
  baseURL: `${API_URL}`,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    config.headers.Authorization = getAuthHeader();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const accounts_ms = axios.create({
  baseURL: ACCOUNTS_MS_API_URL,
});

export const ride_ms = axios.create({
  baseURL: RIDE_MS_URL,
});

accounts_ms.interceptors.request.use((config) => {
  config.headers.Authorization = getAuthHeader();
  return config;
});

ride_ms.interceptors.request.use((config) => {
  config.headers.Authorization = getAuthHeader();
  return config;
});

// api.interceptors.response.use(
//   (response) => {
//     // if (response.data.status !== 200) {
//     //   handleLogout();
//     // }
//     return response;
//   },
//   (error) => {
//     if (error.response.status === 401) {
//       handleLogout();
//       console.log(error.response);
//     }
//     return Promise.reject(error);
//   }
// );

export default api;
